import { shipmentApiClient } from '../shipmentApiClient'
import { downloadDeliveryWorkAttachmentEndpoint } from './endpoint'
import type { DownloadDeliveryWorkAttachmentParams } from './type'

/**
 * 納品作業の添付ファイルをダウンロードする。
 *
 * BE は Content-Type: application/octet-stream 固定でバイナリを返すため Blob で受け取る。
 * 呼び出し側で URL.createObjectURL(blob) を使ってプレビュー / ダウンロードする。
 */
export const downloadDeliveryWorkAttachment = async (
  params: DownloadDeliveryWorkAttachmentParams
): Promise<Blob> => {
  const { data } = await shipmentApiClient.get<Blob>(
    downloadDeliveryWorkAttachmentEndpoint(params.shipmentUid, params.visitId, params.attachmentId),
    {
      params: { deliveryReportUid: params.deliveryReportUid },
      responseType: 'blob',
    }
  )
  return data
}
